<template>
  <div>
    <b-container class="text-left">
      <h1 class="mt-2 mb-2">Cég hozzáadása</h1>

      <b-row>
        <b-col class="mt-4 mb-4 mr-3" cols="12" lg="8" xl="8">
          <h2>Már csak egy lépés van hátra a regisztráció befejezéséig!</h2>
          <p class="mt-4 text-justify text-gray-04">
            Az Ön által kiválasztott és képviselt céget összekötjük a profiljával, így a későbbiekben is tájékozódhat az
            aktuális fejlesztési lehetőségekről.
          </p>
        </b-col>
      </b-row>

      <div class="mt-2">
        <b-row>
          <b-col cols="12" lg="8" xl="8">
            <b-form>
              <div class="bg-color-lightblue rounded p-5">
                <h2 v-if="selectedCompany" class="mb-3">{{ selectedCompany.long_name[0].name }}</h2>
                <h2 v-if="fundMapCompany" class="mb-3">{{ fundMapCompany.long_name[0].name }}</h2>
                <label for="position">Cégben betöltött tisztség</label>
                <b-form-group>
                  <b-form-select v-model="selectedPosition" :options="positionOptions" id="position" class="w-75">
                    <template #first>
                      <b-form-select-option :value="null" disabled>Cégben betöltött tisztség</b-form-select-option>
                    </template></b-form-select
                  >
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="statement"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                    class="mt-3"
                  >
                    Elfogadom a
                    <a download target="_blank" href="https://vali.hu/static/felhasznalasi_feltetelek.pdf">
                      Felhasználási feltételeket
                    </a>
                  </b-form-checkbox>
                </b-form-group>
                <b-button
                  class="mt-4"
                  type="submit"
                  variant="primary"
                  @click.prevent="onConfirmationSubmission"
                  :disabled="isLoading"
                >
                  <b-spinner small v-if="isLoading"></b-spinner>
                  <span class="sr-only" v-if="isLoading">Betöltés...</span>
                  <span v-if="!isLoading">Hozzáadás</span>
                </b-button>
              </div>
            </b-form>
            <br />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      selectedPosition: null,
      positionOptions: [
        { value: 'OWNER', text: 'Tulajdonos' },
        { value: 'SENIOR_OFFICER', text: 'Vezető tisztségviselő' },
        { value: 'ACCOUNTANT', text: 'Könyvelő' },
        { value: 'APPLICATION_WRITER', text: 'Pályázatíró' },
        { value: 'CONSULTANT', text: 'Tanácsadó' }
      ],
      statement: 'not_accepted'
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'selectedCompany', 'getUser', 'selectedUserCompany', 'userCompanies', 'fundMapCompany'])
  },
  methods: {
    // getPositions() {},
    async onConfirmationSubmission() {
      if (this.statement == 'not_accepted') {
        this.$store.dispatch('notify', {
          newNotification: { type: 'info', message: 'A felhasználási feltételek elfogadása kötelező.' }
        })
      } else {
        if (this.selectedPosition) {
          let userCompanyData = {}
          if (this.selectedCompany) {
            userCompanyData = {
              companyId: this.selectedCompany.flaggerId,
              position: this.selectedPosition
            }
          } else if (this.fundMapCompany) {
            userCompanyData = {
              companyId: this.fundMapCompany.flaggerId,
              position: this.selectedPosition
            }
          }

          await this.$store.dispatch('createUserCompany', userCompanyData)

          const getParams = {}
          await this.$store.dispatch('getUserCompanies', getParams)
          const createdCompany = this.userCompanies.filter(function(userCompany) {
            return userCompany.companyId === userCompanyData.companyId
          })

          this.$store.commit('setSelectedUserCompany', createdCompany[0]._id)

          const getCompanyQueryParams = { value: createdCompany[0].companyId }
          await this.$store.dispatch('getCompany', getCompanyQueryParams)
          this.$store.commit('setSelectedUserCompany', createdCompany[0])
          if (this.$route.query.redir == 'kkv-result') {
            this.$router.push({ path: this.$route.query.redir, query: { companyId: this.$route.query.companyId } })
            return
          }

          if (this.$route.query.redir && this.$route.query.redir.includes('fund-map')) {
            return this.$router.push({ path: this.$route.query.redir })
          }

          this.$router.push({ path: '/company-offers-private', query: { companyId: userCompanyData.companyId } })
        } else {
          this.$store.dispatch('notify', {
            newNotification: { type: 'info', message: 'A cégben betöltött tisztség kiválasztása kötelező.' }
          })
        }
      }
    },
    filteredUserCompany(selectedId) {
      return this.userCompanies.filter(function(company) {
        return company.companyId === selectedId
      })
    }
  },
  mounted() {
    const companyId = this.$route.query.companyId
    if (this.filteredUserCompany(companyId).length != 0) {
      if (this.$route.query.redir == 'kkv-result') {
        this.$router.push({ path: 'kkv-result', query: { companyId: this.$route.query.companyId } })
        return
      }
    }
  }
}
</script>

<style scoped>
.btn {
  min-height: 48px;
  width: 235px;
}
</style>
